import { render, staticRenderFns } from "./marketList.vue?vue&type=template&id=4cac2c5e&scoped=true"
import script from "./marketList.vue?vue&type=script&lang=js"
export * from "./marketList.vue?vue&type=script&lang=js"
import style0 from "./marketList.vue?vue&type=style&index=0&id=4cac2c5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cac2c5e",
  null
  
)

export default component.exports